<template>
    <div class="scan" :style="{background: color}">
        <div class="header">
            <img :src="detail.imgurl" alt="">
        </div>
        <div class="body">
            <div class="tabs">
                <div :class="[active==item.id?'active':'','tab']" @click="active = item.id" v-for="item in tablist" :key="item.id">{{item.name}}</div>
            </div>
            <div class="centent">
                <div class="html">                       
                    <div v-html="active==1?detail.disclaimer:detail.intro"></div>
                </div>
            </div>
            <div class="foot">
                <img @click="godetail()" src="https://oss.mcloud.moveclub.cn/alphamovecloud/20240423/1713854810/864964.jpg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import "./index.less";
export default {
    data() {
        return {
            detail: {},
            tablist: [
                {
                    id: 1,
                    name: '活动规则'
                },{
                    id: 2,
                    name: '奖励办法'
                }
            ],
            sublist: [],
            active: 1,
            activity_id: '',
            sub_aid: '',
            color: '#2CC5DD'
        };
    },
    methods: {
        godetail() {
            this.$router.push({name:'scanDetail',params:{'acid':this.activity_id}})
        },
        init: function () {
            this.$toast.loading({
                duration: 1000,
            });
            let params = { activity_id: this.activity_id };
            this.$api.activity.taskList(params).then(res => {
                if(res.status==200){
                    let arr = []
                    if(res.data.short_desc.length>0){
                        arr = JSON.parse(res.data.short_desc)
                        this.color = arr[4]
                    }
                    this.detail = res.data
                }
            });
        },
    },
    mounted() {
        this.activity_id = this.$route.params.acid
        this.sub_aid = this.$route.params.sub_aid
        this.init();
    },
}
</script>